import { FC } from "react";
import { Helmet } from "react-helmet";
import { useInstituteContext } from "../../../context/institute.context";
import { withInstituteTabTitle } from "../../../utils/withInstituteTabTitle";

export type DocumentTitleProps = {
  title: string;
};

const DocumentTitle: FC<DocumentTitleProps> = ({ title }) => {
  const { selectedInstitute } = useInstituteContext();
  return (
    <Helmet>
      <title>{withInstituteTabTitle(selectedInstitute?.name, title)}</title>
    </Helmet>
  );
};

export default DocumentTitle;
